// extracted by mini-css-extract-plugin
module.exports = {"SubmitSelections":"SubmitSelections_SubmitSelections__nWC5V","MainContent":"SubmitSelections_MainContent__1HcRk","Controls":"SubmitSelections_Controls__3c_36"};